import React from 'react'

import Section from '../Section'
import { Row, Col } from 'components/Layout'
import Markdown from 'features/Markdown'
import CmsImg from 'features/Cms/Utils/CmsImg'

import s from './Col2TextPicture.scss'
import sText from 'components/Text/Text.scss'
import sLay from 'styles/modules/layout.scss'
import cn from 'classnames'

export default props => {
  const alignContentClass =
    sLay[`layout-align-${props.alignContent}-center`] || sLay['layout-align-center-center']
  const textColClass = sLay[`flex-${props.textColumnWidth}`] || sLay.flex

  return (
    <Section
      color={props.color}
      fullHeight={props.fullHeight}
      paddingTop={props.paddingTop}
      paddingBottom={props.paddingBottom}
      pattern={props.pattern}
    >
      <Row className={cn(sLay['layout-xs-column'], sLay['layout-gt-xs-row'])}>
        <Col
          className={cn(
            sLay['layout-column'],
            sLay['layout-align-center'],
            textColClass,
            sLay['flex-xs-100'],
            s.centerOnMobile
          )}
        >
          {props.sectionName && (
            <div className={cn(sText.heading5, sText.accent)} style={{ marginBottom: '10px' }}>
              {props.sectionName}
            </div>
          )}

          <Markdown text={props.text} color={props.color} />

          {props.text2 && <Markdown text={props.text2} color={props.color} />}
        </Col>

        <Col className={cn(s.col2, sLay['layout-column'], alignContentClass, sLay['flex-gt-xs'])}>
          <div style={{ width: props.pictureWidth || '100%' }}>
            <CmsImg src={props.picture} phoneMockup={props.phoneMockup} />
            {props.caption && (
              <div style={{ marginTop: '10px' }} className={sText.descrip4}>
                {props.caption}
              </div>
            )}
          </div>
        </Col>
      </Row>
    </Section>
  )
}



// WEBPACK FOOTER //
// ./~/@pickle/pickle-shared/src/features/Cms/Sections/Col2TextPicture/Col2TextPicture.jsx